/** @format */

import styled from "styled-components"
import { colorPalette } from "@ui-library/myslpro"
import SvgIconBuyMore from "@local/icons/component/IconBuyMore"
import { Popin } from "@ui-library/core"

export const StyledPopin = styled(Popin)`
	.content-wrapper {
		padding: 0px 0px 0px 0px;
	}
`

export const IconBuyMore = styled(SvgIconBuyMore)`
	height: 192px;
	width: 203.17px;
`

export const Body = styled.div`
	align-items: center;
	display: flex;
	flex-direction: column;
	gap: 24px;
	padding: 0px 32px 48px;
	position: relative;

	.illu-woman-listing {
		height: 192px;
		position: relative;
		width: 203.17px;
	}

	.overlap-group {
		height: 192px;
		position: relative;
		width: 203px;
	}

	.thumbs-form {
		align-items: center;
		align-self: stretch;
		display: flex;
		flex: 0 0 auto;
		flex-direction: column;
		gap: 16px;
		position: relative;
		width: 100%;
	}

	.title {
		align-self: stretch;
		color: ${colorPalette.greyDark};
		font-family: "Source Sans Pro";
		font-size: 24px;
		font-style: normal;
		font-weight: 700;
		letter-spacing: 0px;
		line-height: 30px;
		top: 0;
		text-align: center;
		width: 500px;
	}

	.text-wrapper {
		height: 44px;
		width: 500px;
		color: #2b2b2b;
		font-family: "Source Sans Pro";
		font-size: 16px;
		font-weight: 600;
		letter-spacing: 0;
		line-height: 22px;
		text-align: center;
		margin: 0;
	}

	.buttons {
		align-items: flex-start;
		display: inline-flex;
		flex: 0 0 auto;
		gap: 8px;
		position: relative;
	}

	.tertiary-button-border {
		border: 2px solid #707070;
	}
`
